export const PACKAGE_VERSION = "0.50.0";
//# sourceMappingURL=package-version.js.map